<template>
  <!-- footer component of every page -->
  <footer class="p-2">
    <p class="m-0">Copyright &copy; 2021 motivately</p>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style scoped>
  footer {
    color: #705133;
    text-align: center;
    background-color: #BDD7C1;
  }
</style>
